module.exports = __webpack_public_path__ + "assets/img/139.96da17e8.png";